
import React from 'react';
import { RideFormData } from '@/types/ride';
import EnhancedRideForm from './forms/EnhancedRideForm';

interface RideFormProps {
  onSubmit: (data: RideFormData) => void;
}

const RideForm: React.FC<RideFormProps> = ({ onSubmit }) => {
  return <EnhancedRideForm onSubmit={onSubmit} />;
};

export default RideForm;
